<template>
<div>
     <v-navigation-drawer
          class="left-nav-bar"
          color="white"
          :value="true"
          mini-variant
          hide-overlay
          permanent
          absolute>
          <v-list class="py-0" >
              <a href="https://www.retailsolutions.com" target="_blank" rel="noopener noreferrer"><img
                  class="rsi-logo"
                  :src="getImgUrl('bk/rsi-logo.jpg')" ></a>
              <v-divider></v-divider>
             
             
              <div v-for="(item,i) in items"
                  :key="i">
            <v-list-item
                  class="vertical-menu" 
                 v-if="!item.submenu"
                 :disabled="item.disabled"
                  @click="onItemClick(item)"
                   :title="item.tooltip">
                  <v-icon :class="item.disabled?'icons-projects gray--text':'icons-projects black--text'"  >{{ item.icon }}</v-icon>
                  <span class="icon-text" :style="item.marginLeft">{{ item.title }}</span>
              </v-list-item>

            <v-menu  open-on-hover offset-x v-else>
            <template v-slot:activator="{ on, attr }">
              <v-list-item
                  class="vertical-menu" 
                  v-bind="attr"
                  v-on="on"
                  :disabled="item.disabled">
                  <v-icon :class="item.disabled?'icons-projects gray--text':'icons-projects black--text'"  >{{ item.icon }}</v-icon>
                  <span class="icon-text" :style="item.marginLeft">{{ item.title }}</span>
              </v-list-item>
            </template>  
             
         <v-list>
        <v-list-item
          v-for="(menu, index) in item.submenu"
          :key="index"
          :title="menu.tooltip"
          @click="onItemClick(menu)"
        >
          <v-list-item-title>{{ menu.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
 </div>
          </v-list>
        </v-navigation-drawer>
        </div>
</template>
<script>

import loadImageMixin from "@/mixins/loadImageMixin";

export default {
    name:"ApplicationAccessPanel",
    mixins: [loadImageMixin],
    computed: {
        items(){
            return this.$store.getters.getLeftBarItems;
        }
    },
    methods: {
        onItemClick(item) {
             window.open(item.url, "_blank");    
        },
    }
}
</script>
<style lang="scss" scoped>
 .left-nav-bar {
        position: fixed !important;

        .v-list-item--link:before {
            margin-bottom: -9px;
        }

        .vertical-menu {
            margin-top: 3px;
            margin-left: -2px;
            min-height: 51px;


            .icon-text {
                font-size: 11px;
                position: absolute !important;
                white-space: nowrap;
                display: initial;
                margin-top: 41px;
                overflow: visible !important;
                clip: unset !important;
                height: unset !important;
            }
        }

        .bottom-divider {
            margin-top: 24px;
        }

        .vertical-menu-bottom {
            position: fixed !important;
            bottom: 18px;
            margin-left: -2px;


            .icon-text {
                font-size: 11px;
                position: absolute !important;
                white-space: nowrap;
                display: initial;
                margin-top: 41px;
                overflow: visible !important;
                clip: unset !important;
                height: unset !important;

            }
        }
    }


    .rsi-logo {
        height: 34px;
        margin-left: 5px;
        margin-top: 15px;
        margin-bottom: 8px;
        box-shadow: 3px 3px 9px rgba(0, 0, 0, 0.3);

        &:hover {
            //cursor: pointer;
        }
    }

</style>